module.exports = __webpack_public_path__ + "static/media/contact.e07d11ab.png";